import(/* webpackMode: "eager" */ "/var/www/kst-frontend-staging/app/pricing/page.tsx")